---
eyebrow: Manifesto
---

A house is built. An interior is *composed*.

Brian Ellison Design treats interiors the way an architect treats a façade — as the **considered arrangement of light, material, proportion, and use**. Every project begins with how the room will be inhabited; every decision returns to whether it serves that life.

We work in residential, commercial, and hospitality across the Florida coast and beyond. We work in small numbers — a handful of projects at a time — because the work demands it.

The result is interiors that feel inevitable. As though they could not have been any other way.
